/* Updated Home component with fixed-bottom pagination */
import React, { useState, useEffect } from "react";
import NavbarTop from "../components/amotive/NavbarTop";
import Pagination from "react-bootstrap/Pagination";
import "bootstrap/dist/css/bootstrap.min.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const pageSize = 10;

const Home = () => {
  const savedPage = Number(localStorage.getItem("currentPage")) || 1;
  const [page, setPage] = useState(savedPage);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lastPage, setLastPage] = useState(false);

  const [search, setSearch] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    let mounted = true;
    setLoading(true);

    fetch(`http://localhost/esposizione/esposizione.php?page=${page}`)
      .then((res) => res.json())
      .then((json) => {
        if (!mounted) return;
        const rows = json?.AR?.esposizioneAR?.flat?.() || [];

        if (rows.length === 0 && page > 1) {
          setLastPage(true);
          setPage((p) => {
            const prev = Math.max(1, p - 1);
            localStorage.setItem("currentPage", prev);
            return prev;
          });
        } else {
          setData(rows);
          setLastPage(rows.length < pageSize);
          localStorage.setItem("currentPage", page);
        }

        setLoading(false);
      })
      .catch((err) => {
        console.error("Fetch error:", err);
        setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, [page]);

  useEffect(() => {
    if (!search) {
      setFilteredData(data);
      return;
    }

    const s = search.toLowerCase();
    const filtered = data.filter((row) =>
      row["ID Cliente"]?.toString().toLowerCase().includes(s) ||
      row["Ragione Sociale"]?.toLowerCase().includes(s) ||
      row["Partita IVA"]?.toLowerCase().includes(s)
    );
    setFilteredData(filtered);
  }, [search, data]);

  const changePage = (p) => {
    if (p === page || loading) return;
    if (p < 1) return;
    setPage(p);
  };

  const prevPage = () => { if (!loading && page > 1) setPage((p) => p - 1); };
  const nextPage = () => { if (!loading && !lastPage) setPage((p) => p + 1); };

  const overlayStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 10,
  };

  const getVisiblePages = () => {
    if (page === 1) return [1, 2, 3].filter((n) => n > 0 && (!lastPage || n <= page + 1));
    return [page - 1, page, page + 1].filter((n, idx, self) => n > 0 && self.indexOf(n) === idx && (!lastPage || n <= page));
  };

  const visiblePages = getVisiblePages();

  const formatEuro = (value) => {
    if (!value || isNaN(value)) return "0,00 €";
    return Number(value).toLocaleString("it-IT", { style: "currency", currency: "EUR" });
  };

  const exportExcel = () => {
    if (filteredData.length === 0) return;
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Esposizione");
    const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([buf], { type: "application/octet-stream" }), `esposizione_page${page}.xlsx`);
  };

  return (
    <div className="main-container-pro bg-dark text-light" style={{ minHeight: "100vh", position: "relative", paddingBottom: "70px" }}>
      <NavbarTop />

      <div className="d-flex justify-content-between align-items-center p-3 flex-wrap gap-2">
        <input
          type="text"
          className="form-control rounded-pill w-25"
          placeholder="Cerca ID Cliente, Ragione Sociale o Partita IVA..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <button className="btn btn-success rounded-pill" onClick={exportExcel}>Esporta Excel</button>
      </div>

      <div className="table-responsive" style={{ padding: "20px", position: "relative" }}>
        {loading && (
          <div style={overlayStyle}>
            <div className="spinner-border text-light" role="status" aria-hidden="true" />
          </div>
        )}
<table className="table table-dark table-hover">
  <thead
    style={{
      background:
        "linear-gradient(90deg, rgb(204,76,17) 0%, rgb(241,111,36) 50%)",
    }}
  >
    <tr>
      <th>ID Cliente</th>
      <th>Ragione Sociale</th>
      <th>Partita IVA</th>
      <th>Pagamento</th>
      <th>Fido Concesso</th>
      <th>Fido Credit Safe</th>
      <th>Assicurazione SACE</th>
      <th>Fatturato 12M</th>
      <th>Fatturato YTD</th>
      <th>Esposizione</th>
      <th>Esposizione Attuale</th>
    </tr>
  </thead>

  <tbody>
    {filteredData.length === 0 ? (
      <tr>
        <td colSpan="11" className="text-center">
          {loading ? "Caricamento..." : "Nessun dato trovato"}
        </td>
      </tr>
    ) : (
      filteredData.map((row, idx) => {
        const esposizione = Number(row["Esposizione"]) || 0;
        const sace = Number(row["Assicurazione SACE"]) || 0;
        const espo = sace - esposizione;

        return (
          <tr key={idx}>
            <td>{row["ID Cliente"]}</td>
            <td>{row["Ragione Sociale"]}</td>
            <td>{row["Partita IVA"]}</td>
            <td>{row["Pagamento"]}</td>
            <td>{formatEuro(row["Fido Concesso"])}</td>
            <td>{formatEuro(row["Fido Credit Safe"])}</td>
            <td>{formatEuro(row["Assicurazione SACE"])}</td>
            <td>{formatEuro(row["Fatturato 12M"])}</td>
            <td>{formatEuro(row["Fatturato YTD"])}</td>
            <td>{formatEuro(esposizione)}</td>
            <td>{formatEuro(espo)}</td>
          </tr>
        );
      })
    )}
  </tbody>
</table>

      </div>

      {/* Fixed-bottom Pagination */}
      <div style={{ position: "fixed", bottom: 0, left: 0, width: "100%", background: "#111", padding: "10px 0", zIndex: 50 }}>
        <div className="d-flex justify-content-center gap-2">
          <Pagination className="custom-pagination">
            <Pagination.Prev disabled={page === 1 || loading} onClick={prevPage} />
            {visiblePages.map((p) => (
              <Pagination.Item key={p} active={p === page} onClick={() => changePage(p)} disabled={loading}>
                {p}
              </Pagination.Item>
            ))}
            <Pagination.Next disabled={lastPage || loading} onClick={nextPage} />
          </Pagination>
        </div>
      </div>
    </div>
  );
};

export default Home;
